import { z } from "zod";

/**
 * A business unit, as Governance writes it and as the company pickers read it.
 *
 * `head` is optional. The collection is now the company vocabulary offered on
 * the attendee form and on a person's own profile as well as the list the
 * spreadsheet import validates against, and the standard Holtzbrinck units are
 * seeded without a named head. `firestore.rules` matches this; requiring a head
 * there would have made every seeded unit unupdatable in Governance.
 */
export const businessUnitSchema = z.object({
  name: z.string().min(1).max(200),
  head: z.string().max(200).optional(),
  createdAt: z.any().optional(),
});

export type BusinessUnit = z.infer<typeof businessUnitSchema>;
